import moment from 'moment';

export function dateHumanFilter() {
	// minute constants
	const MINUTE = 60;
	const HOUR = 60 * MINUTE;
	const DAY = 24 * HOUR;
	const MONTH = 30 * DAY;
	// filter function
	return (date, emptyValue = '') => {
		if (!date) {
			return emptyValue;
		}
		date = moment(date);
		if (!date.isValid()) {
			return emptyValue;
		}
		let now = Math.floor(+new Date() / 1000);
		let diff = now - date.unix();
		if (diff < MINUTE) {
			return 'just now';
		} else if (diff < HOUR) {
			return Math.floor(diff / MINUTE) + 'm ago';
		} else if (diff < DAY) {
			return Math.floor(diff / HOUR) + 'h ago';
		} else if (diff < MONTH) {
			return Math.floor(diff / DAY) + 'd ago';
		} else {
			return date.format('MMM YYYY');
		}
	};
}
